
import { OperatorsType } from '@/interface/numberSysytem';

import ItemCardContainer, { CardData } from './cards';
import styles from './index.module.less';

export const ACTIVATION_COND = 'activationCond';
export const NUM_CHANGE = 'numChange';

const MultiCardContainer: React.FC<{
  value: {
    activationCond: CardData[];
    numChange: CardData[];
  };
  actionCondErrorMsg?: string;
  numChangeErrorMsg?: string;
  onChange: (cond: {
    activationCond: CardData[];
    numChange: CardData[];
  }) => void;
  disabled: boolean;
}> = (props) => {
  const { value, disabled, actionCondErrorMsg, numChangeErrorMsg, onChange } = props;
  const { activationCond = [], numChange = [] } = value || {};
  const handleChange = (fileName: string, val: CardData[]) => {
    // 第一项都要重置运算项目
    const newVal = val?.map((e, i) => ({
      ...e,
      logicalOp: i === 0 ? OperatorsType.DEFAULT : e?.logicalOp,
      opGroup: e?.opGroup?.map((opG, j) => {
        if (j === 0) {
          return {
            ...opG,
            op: OperatorsType.DEFAULT,
          };
        }
        return opG;
      }),
    })) || [];
    onChange({
      ...value,
      [fileName]: newVal,
    });
  };


  return (
    <div className={styles.container}>
      <div className={styles.activationCond}>
        <ItemCardContainer
          label='激活选项条件'
          fileName={ACTIVATION_COND}
          disabled={disabled}
          value={activationCond}
          onChange={(val) => {
            handleChange(ACTIVATION_COND, val);
          }}
        />
      </div>
      {
        actionCondErrorMsg ? <div className={styles.errorMsg}>{actionCondErrorMsg}</div> : null
      }
      <ItemCardContainer
        label='选后数值变化'
        fileName={NUM_CHANGE}
        disabled={disabled}
        value={numChange}
        onChange={(val) => {
          handleChange(NUM_CHANGE, val);
        }}
      />
      {
        numChangeErrorMsg ? <div className={styles.errorMsg}>{numChangeErrorMsg}</div> : null
      }
    </div>
  );
};

export default MultiCardContainer;
